// extracted by mini-css-extract-plugin
var _1 = "LoginFormEmailFields-moduleformFields__xrNKo FormFieldsContainer-moduleFormFieldsContainer__u1JJu";
export { _1 as "formFields" }
